import { create } from 'zustand';

import type { ChatTransport } from '@/services/chat/chatTransport';

type ChatTransportUpdate =
  | ChatTransport
  | undefined
  | ((current: ChatTransport | undefined) => ChatTransport | undefined);

type ChatTransportState = {
  transport: ChatTransport | undefined;
  setTransport: (update: ChatTransportUpdate) => void;
};

/**
 * The chat transport the signed-in session is using, once it is ready to open
 * conversations. Empty while signed out and while a session is connecting.
 *
 * Only the session code that builds a transport writes here. Everything else
 * reads it through `useChatTransport` and never learns which transport it is.
 */
export const useChatTransportStore = create<ChatTransportState>((set) => ({
  transport: undefined,
  setTransport: (update) =>
    set((state) => ({
      transport: typeof update === 'function' ? update(state.transport) : update,
    })),
}));

export const selectChatTransport = (state: ChatTransportState) => state.transport;

export const selectSetChatTransport = (state: ChatTransportState) => state.setTransport;
